import { type FetchQueryOptions, useQuery } from "@tanstack/react-query";

import { readDexSdk } from "../dex-sdk";

export interface GetTriggerResetMintTsArgs {
  enabled?: boolean;
}

export function triggerResetMintTsQueryKey() {
  return ["triggerResetMintTs"] as const;
}

export function triggerResetMintTsQuery() {
  return {
    queryKey: triggerResetMintTsQueryKey(),
    queryFn: async () => {
      return await readDexSdk.getTriggerResetMintTs();
    },
  } satisfies FetchQueryOptions;
}

/**
 * Query to get the timestamp when the global restricted mint limits for NEW accounts reset (in seconds).
 *
 * @remarks This query is temporary and only for use in testnet. The restricted_mint_daily_reset_timestamp
 * view function is a testnet-only feature and should be removed before mainnet deployment.
 */
export function useTriggerResetMintTs(args: GetTriggerResetMintTsArgs) {
  return useQuery({
    ...triggerResetMintTsQuery(),
    enabled: args.enabled ?? true,
  });
}
